import { Component, Input, OnInit } from "@angular/core";
import { ClientMessage } from "src/app/shared/models/search-result";
import { TranslationRequest } from "src/app/shared/models/translation/translation-request";
import { UtilityService } from "../../services/utility.service";
import { TranslationService } from "../../services/translation.service";
import { Session } from '../../services/session.service';

@Component({
    selector: 'app-custom-message',
    template: `
  @if (!utility.isNullOrEmpty(clientMessage)) {
    <p class="app-pb1 tw-w-full">
      <br>
      <b><div
        [innerHTML]="
          clientMessageTranslationKey()
            | translationClientCustomization
              : clientMessage
              : translationRequest
              : true
            | safeHtml
        "
      ></div></b>
    </p>
  }`,
    styles: [],
    standalone: false
})

export class CustomMessageComponent implements OnInit {

  constructor(public utility: UtilityService, 
    private translationService: TranslationService,
    public session: Session){
  }
  @Input()
  listClientMessage? : ClientMessage[];

  clientMessage: string;

  clientMessageId: string;

  @Input()
  lob: string = '';

  @Input()
  keyForMessage: string;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: this.lob,
    group: 'Shared',
    subGroup: 'Shared',
    multipleKeyAllowed: 'ClientMessage'
  });

  clientMessageTranslationKey(): string {
    if (this.utility.isNullOrEmpty(this.clientMessageId)) {
      return 'ClientMessage';
    }
    return `ClientMessage|${this.clientMessageId}`;
  }

  async ngOnInit(): Promise<void> {
    if (this.translationService.isLanguagePreferenceSet()) {
      await this.translationService.mergeTranslationsFromRequest(
        new TranslationRequest({
          language: sessionStorage.getItem('languagepreference'),
          key: null,
          contNum: Number(this.session.user.contNum),
          tableName: null,
          primaryKey: null,
          primaryValue: null,
          lob: null,
          group: 'ClaimSummary',
          subGroup: 'ClaimSummary',
          multipleKeyAllowed: 'ClientMessage',
        })
      );
    }

      if (this.listClientMessage && this.listClientMessage.length > 0 && !this.utility.isNullOrEmpty(this.keyForMessage)) {
        const clientMessageEntry = this.listClientMessage.find(
          (x) => x.keyTab == this.keyForMessage
        );
          this.clientMessage = clientMessageEntry?.message;
          this.clientMessageId = clientMessageEntry?.messageId;
      }

  }
}
